import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// Imported for its side effects, and imported *before* App: initialising
// i18next and stamping `lang`/`dir` onto <html> at module load means the first
// render already has its dictionary, so no view flashes raw translation keys.
import './locales'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
